import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div style={styles.container}>
          <div style={styles.icon}>⚠</div>
          <p style={styles.title}>Something went wrong</p>
          <p style={styles.message}>
            {this.state.error?.message || "An unexpected error occurred."}
          </p>
          <button
            style={styles.button}
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    border: "1px solid #fee2e2",
    borderRadius: 10,
    background: "#fff5f5",
    margin: "16px 0",
  },
  icon: {
    fontSize: 32,
    marginBottom: 8,
  },
  title: {
    fontWeight: 600,
    fontSize: 16,
    color: "#b91c1c",
    margin: "0 0 4px",
  },
  message: {
    fontSize: 13,
    color: "#6b7280",
    margin: "0 0 16px",
    textAlign: "center",
  },
  button: {
    padding: "8px 20px",
    background: "#1B2E56",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 13,
  },
};

export default ErrorBoundary;
